// extracted by mini-css-extract-plugin
export var chevronIcon = "_bj-2";
export var teamName = "_bj-1";
export var teamSwitcherButton = "_bj-0";